import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Button } from 'grommet';
import { Close } from 'grommet-icons';
import styled from 'styled-components';

import { intersection } from '../../lib/nodash';
import ColorFilterPanelItem from './ColorFilterPanelItem';
import TextTitle from '../TextTitle';

const FilterContainer = styled(Box)`
  flex-direction: ${(p) => (p.verticalOnly ? 'column' : 'row')};
  @media only screen ${(p) =>
      p.theme.global.breakpoints.small.value &&
      `and (min-width: ${p.theme.global.breakpoints.small.value}px)`} {
    flex-direction: column;
  }
`;

const ColorFilterPanelGroup = ({
  filters = [],
  valueKey,
  labelKey,
  activeFilters = [],
  activeSorts = [],
  onTagFilter,
  onSort,
  onResetFilters,
  baseUrl,
  title,
  pad,
  includeTitle = true,
  canonicalLinks = true,
  verticalOnly = false,
}) => {
  const hasActiveFilters = intersection(activeFilters, filters).length > 0;
  return (
    <Box width="100%">
      {includeTitle && !!onResetFilters && (
        <Box
          direction="row"
          gap="medium"
          justify="between"
          pad={{ horizontal: pad, vertical: 'small' }}
        >
          {includeTitle && (
            <Text size="small" weight={500}>
              Filter by {title}
            </Text>
          )}
          {hasActiveFilters && !!onResetFilters && (
            <Button
              style={{
                padding: 0,
              }}
              size="small"
              aria-label="Reset"
              label={
                <TextTitle color="dark-2" size="xsmall">
                  Reset
                </TextTitle>
              }
              reverse
              icon={<Close size="small" color="black" />}
              onClick={() => onResetFilters(filters)}
            />
          )}
        </Box>
      )}
      <Box overflow="auto" fill="horizontal">
        <div>
          <FilterContainer
            gap="xsmall"
            pad={{ bottom: 'medium', top: 'small', horizontal: pad }}
            justify="start"
            align="start"
            verticalOnly={verticalOnly}
          >
            {filters
              .filter((x) => x.component !== 'Separator')
              .map((x, i) => {
                return (
                  <Box key={x[valueKey] || i} flex={false}>
                    <ColorFilterPanelItem
                      item={x}
                      valueKey={valueKey}
                      labelKey={labelKey}
                      onTagFilter={onTagFilter}
                      onSort={onSort}
                      size="medium"
                      baseUrl={baseUrl}
                      canonicalLinks={canonicalLinks}
                      layout={verticalOnly ? 'horizontal' : 'vertical'}
                      isActive={
                        x._uid
                          ? activeFilters.map((y) => y._uid).includes(x._uid) ||
                            activeSorts.map((y) => y._uid).includes(x._uid) ||
                            activeSorts.map((y) => y.id).includes(x.slug)
                          : activeFilters.map((y) => y.id).includes(x.id) ||
                            activeSorts.map((y) => y.id).includes(x.id) ||
                            activeSorts.map((y) => y.id).includes(x.slug)
                      }
                    />
                  </Box>
                );
              })}
          </FilterContainer>
        </div>
      </Box>
    </Box>
  );
};

ColorFilterPanelGroup.propTypes = {
  activeFilters: PropTypes.array,
  activeSorts: PropTypes.array,
  filters: PropTypes.array,
  onTagFilter: PropTypes.func,
  onSort: PropTypes.func,
  onResetFilters: PropTypes.func,
  open: PropTypes.bool,
  baseUrl: PropTypes.string,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  title: PropTypes.string,
  pad: PropTypes.string,
  includeTitle: PropTypes.bool,
  canonicalLinks: PropTypes.bool,
  verticalOnly: PropTypes.bool,
};

export default ColorFilterPanelGroup;
